export default __webpack_public_path__ + "static/media/home.ef44621d.svg";